import React from 'react';
import { motion } from 'framer-motion';
export function IntakeSlideTransition({
  children,
  direction = 1,
  isDark = false
}: {
  children: ReactNode;
  direction?: number;
  isDark?: boolean;
}) {
  return <motion.div key="slide" initial={{
    opacity: 0,
    x: 20 * direction
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20 * direction
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className={`w-full h-full flex flex-col absolute inset-0 ${isDark ? 'bg-slate-950' : 'bg-white'}`} data-id="element-423">
      {children}
    </motion.div>;
}